/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import MockAdapter from 'axios-mock-adapter';
import { BaseFeatureMock } from '../mockServer/featureMock';
import { MainStatisticsDto } from './mainStatisticsClient.typings';
import { interval, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';

const MAIN_STATISTICS_URL_RE = '1.0.0/dashboard/counters';

const createInitialMainStatistics = (): MainStatisticsDto => ({
    year: {
        cashBoxes: 4326,
        vatSum: 1451005295.43,
        docCount: 365117614,
        turnover: 10450022145.69,
    },
    today: {
        cashBoxes: 27579,
        vatSum: 235341961,
        docCount: 861,
        turnover: 16655447.39,
    },
});

export class MainStatisticsBackendStore {
    private mainStat: MainStatisticsDto = createInitialMainStatistics();
    private updateSubscription?: Subscription;

    public startUpdates(updateDataEveryMs: number): void {
        if (!this.updateSubscription) {
            this.updateSubscription = interval(updateDataEveryMs)
                .pipe(tap(() => this.updateData()))
                .subscribe();
        }
    }

    private updateData(): void {
        this.mainStat.year.cashBoxes = this.mainStat.year.cashBoxes + 1;
        this.mainStat.year.vatSum =
            this.mainStat.year.vatSum + Math.round((Math.random() < 0.5 ? 1 : -0.5) * Math.random() * 500);
        this.mainStat.year.docCount = this.mainStat.year.docCount + Math.floor(Math.random() * 100) + 10;
        this.mainStat.year.turnover =
            this.mainStat.year.turnover + Math.round((Math.random() < 0.5 ? 1 : -0.9) * Math.random() * 1500);

        this.mainStat.today.cashBoxes = this.mainStat.today.cashBoxes + Math.floor(Math.random() * 20) + 5;
        this.mainStat.today.vatSum =
            this.mainStat.today.vatSum + Math.round((Math.random() < 0.5 ? 1 : -0.5) * Math.random() * 500);
        this.mainStat.today.docCount = this.mainStat.today.docCount + Math.floor(Math.random() * 100) + 10;
        this.mainStat.today.turnover =
            this.mainStat.today.turnover + Math.round((Math.random() < 0.5 ? 1 : -0.9) * Math.random() * 1500);
    }

    public getMainStat(): MainStatisticsDto {
        return this.mainStat;
    }
}

class MainStatisticsFeatureMock extends BaseFeatureMock {
    private backend = new MainStatisticsBackendStore();

    public readonly counters = this.route<MainStatisticsDto>({
        method: 'get',
        url: MAIN_STATISTICS_URL_RE,
        defaultResponse: () => [200, this.backend.getMainStat()],
        delayMs: 300,
    });

    public startUpdates(): void {
        this.backend.startUpdates(1200);
    }

    protected onReset(): void {
        this.backend = new MainStatisticsBackendStore();
    }
}

export const mainStatisticsMock = new MainStatisticsFeatureMock();

/** Backward-compat shim - dev mock mode (mockAdapter.ts) keeps calling this untouched. */
export function addMainStatisticsMockApi(mockAdapter: MockAdapter): void {
    mainStatisticsMock.startUpdates();
    mainStatisticsMock.register(mockAdapter, { delay: true });
}
